const auth = {
    namespaced: true,
    state: () => ({
        student: null,
        token: "",
    }),
    mutations: {
        token: (state, token) => {
            state.token = token ? token:"";
            localStorage.setItem("student-token", token ? token:"");
            axios.defaults.headers.common["Authorization"] = ` Bearer ${token}`;
        },
        student: (state, student) => {
            state.student = student;
        },
    },

    actions: {
        async logout({ commit }) {
            await axios
                .post("logout")
                .then((resp) => {
                    commit("token", "");
                })
                .catch((err) => {})
                .finally(() => {});
        },
        load: ({ commit }) => {
            const token = localStorage.getItem("student-token");
            commit("token", token);
            axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        },
    },
};

export default auth;
